import styled from "styled-components";
import { Colors } from "../../../../constants/Colors";

interface Props {
  negative?: boolean;
}

const returnBgColor = (negative?: boolean, disabled?: boolean) => {
  if(negative) return Colors.commons.darkGray;
  if(disabled) return Colors.commons.grayFading;
  return Colors.primary[100];
}

export const ButtonWrapper = styled.button<Props>`
  all: unset; /* Remove todos os estilos nativos */
  cursor: pointer;
  /* font-family: inherit; */
  font-weight: normal;
  font-size: 1.5rem;

  color: ${({ negative }) =>
    negative ? "white" : "white"};

  text-decoration: none;
  outline: none;

  background-color: ${({ negative, disabled}) => returnBgColor(negative, disabled)};

  height: 100%;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  border: ${({ negative }) =>
    negative ? "0" : "0"} solid black;

  &:hover {
    text-decoration: none;
  }

  &:focus {
    text-decoration: none;
  }
`;
